export default __webpack_public_path__ + "static/media/paid-employment.8188cd10.svg";